import styled from 'styled-components'

import * as ds from '@ulule/owl-kit-components/next'

export const Aside = styled.div``

export const Controls = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 35px;
  margin-top: 12px;
`

export const DesktopContainer = styled.div`
  display: none;

  @media screen and ${ds.BREAKPOINTS.TABLET} {
    display: block;
  }
`

export const Main = styled.div`
  margin-bottom: 50px;
  @media screen and ${ds.BREAKPOINTS.TABLET} {
    margin-bottom: 0;
  }
`

export const MobileContainer = styled.div`
  display: block;

  @media screen and ${ds.BREAKPOINTS.TABLET} {
    display: none;
  }
`

export const Wrapper = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 32px;

  @media screen and ${ds.BREAKPOINTS.TABLET} {
    grid-template-columns: repeat(2, 1fr);

    ${Aside} {
      grid-area: 1 / 1 / span 1 / span 1;
    }

    ${Main} {
      grid-area: 1 / 2 / span 1 / span 1;
    }
  }

  @media screen and ${ds.BREAKPOINTS.LAPTOP} {
    grid-template-columns: repeat(3, 1fr);

    ${Aside} {
      grid-area: 1 / 1 / span 1 / span 1;
    }

    ${Main} {
      grid-area: 1 / 2 / span 1 / span 2;
    }
  }

  @media screen and (min-width: 1240px) {
    grid-template-columns: repeat(4, 1fr);

    ${Aside} {
      grid-area: 1 / 1 / span 1 / span 1;
    }

    ${Main} {
      grid-area: 1 / 2 / span 1 / span 3;
    }
  }
`

export const ScrollAnchor = styled.div`
  position: absolute;
  z-index: -1;
  top: -20px;

  @media screen and ${ds.BREAKPOINTS.TABLET} {
    top: -65px;
  }
`
